import { createFileRoute, redirect } from '@tanstack/react-router'
import { databases } from '@/lib/appwrite'
import type { Instrument } from '@/Wist-blockchain/collections/instruments/types'
import AddServiceReport from '@/Wist-blockchain/serviceReport/view/user/addServiceReport'
import type { Company } from '@/lib/collections/organizations/getOrganizationsFetch'

const DB = import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID

// Ruta existente: solo para nuevo informe, sin draftId
export const Route = createFileRoute('/_authenticated/instruments/serviceReport/$id/')({
    beforeLoad: ({ context }) => {
        if (!context.user) throw redirect({ to: '/login' })
        const { isServicioTecnico, isAdmin } = context.userRoles
        if (!isServicioTecnico && !isAdmin) throw redirect({ to: '/unauthorized' })
    },
    loader: async ({ params }) => {
        const instrument = await databases.getDocument(
            DB,
            import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_COLLECTION_ID,
            params.id
        ) as unknown as Instrument

        const company = instrument.idOrganization
            ? await databases.getDocument(
                import.meta.env.VITE_APPWRITE_DATABASE_ID,
                import.meta.env.VITE_ORGANIZATIONS_COLLECTION_ID,
                instrument.idOrganization
            ) as unknown as Company
            : undefined

        return { instrument, company }
    },
    errorComponent: () => <div>Instrumento no encontrado.</div>,
    component: RouteComponent,
})

function RouteComponent() {
    const { instrument, company } = Route.useLoaderData()
    return <AddServiceReport instrument={instrument} company={company} />
}